export default "__VITE_ASSET__p8fG37li__"